// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3XkhD","inlineContent":"_3UCvU","pageWrapper":"_3V_xK","root":"_4INfd"};